import { jsx, jsxs } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const OpenDownloadIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 27),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: "2",
    children: /*#__PURE__*/jsxs("g", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [/*#__PURE__*/jsx("path", {
        d: "m13.5 1v17.95"
      }), /*#__PURE__*/jsx("path", {
        d: "m6.77 12.42 6.73 6.73 6.73-6.73"
      }), /*#__PURE__*/jsx("path", {
        d: "m26 19.27v2.24c0 2.49-1.5 4.49-3.33 4.49h-18.34c-1.83 0-3.33-2-3.33-4.49v-2.24"
      })]
    })
  });
};

export { OpenDownloadIcon };
//# sourceMappingURL=open.download.js.map
